export const MEMBER_ROOT = "/user";